import React from 'react';
import { withLocalize } from "react-localize-redux";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { chartActions } from '../../../store/charts/chartsStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';

import '../relationChart.scss';
import '../relationChartFonts.scss';

class ChartCommonTooltip extends React.Component {
    render() {
        const { commonTooltip } = this.props.charts;

        if (isNullOrUndefined(commonTooltip) || !commonTooltip.show || isNullOrUndefined(commonTooltip.context))
            return null;

        const { position, text } = commonTooltip.context;

        return (
            <div id="commonHoverPopup" className="common-hover-popup" style={{ display: 'block', top: `${position.y}px`, left: `${position.x}px` }}>
                {text}
            </div>
        );
    }
}

export default withRouter(withLocalize(connect(
    state => ({ charts: state.charts }),
    dispatch => bindActionCreators({ ...chartActions }, dispatch)
)(ChartCommonTooltip)));